import { Shimmer } from '@components';

export const DetailsDialogLoading = () => {
  return (
    <>
      <Shimmer
        style={{ height: 25, width: '100%', borderRadius: 4, marginBottom: 16 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{ height: 14, width: 240, borderRadius: 4, marginBottom: 16 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{ height: 20, width: 140, borderRadius: 4, marginBottom: 16 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{ height: 550, width: '100%', borderRadius: 4, marginBottom: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
    </>
  );
};
